export const name = '@bigmi/core';
export const version = '0.6.1';
//# sourceMappingURL=version.js.map